import { CityList, ZipcodeCheck } from '@/types/address/addressType'
import { Translator } from '../../types/ApiResponseTypes'
import { isCityListResponse, ZipcodeCheckResponse } from '@/types/address/addressReponse'

class ZipCodeResponseTranslator implements Translator<CityList> {
  convert(response: any): CityList {
    if (isCityListResponse(response)) {
      // Use a Map to keep track of unique city names
      const uniqueCitiesMap = new Map<string, ZipcodeCheck>()

      if (Array.isArray(response)) {
        response.forEach((city: ZipcodeCheckResponse) => {
          const cityModel = this.convertTocityModel(city)
          if (!uniqueCitiesMap.has(cityModel.name)) {
            uniqueCitiesMap.set(cityModel.name, cityModel)
          }
        })

        // Convert the Map values back into an array
        return { cities: Array.from(uniqueCitiesMap.values()) }
      }
    }
    return { cities: [] }
  }

  convertTocityModel(response: ZipcodeCheckResponse): ZipcodeCheck {
    return {
      id: response.cityId,
      name: response.cityName,
    }
  }
}

export default new ZipCodeResponseTranslator()
